module.exports = __webpack_public_path__ + "aba049e25755f0030d3c8a0a754bb71e.svg";


//////////////////
// WEBPACK FOOTER
// ./App/assets/camunda/fonts/opensans-light-webfont.svg
// module id = 311
// module chunks = 0